module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00063-fs8.0d53dbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00063-fs8.png
// module id = 216
// module chunks = 0